export default __webpack_public_path__ + "static/media/lensie.16e6e17a.svg";